import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGraph = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.5 14.2757H14.5M6.05747 8.00008H3.66667C3.50879 8.00304 3.35796 8.09415 3.24631 8.25401C3.13466 8.41386 3.07103 8.62983 3.06897 8.85588V14.2759H6.65517V8.85588C6.65517 8.62891 6.5922 8.41123 6.48011 8.25074C6.36802 8.09024 6.21599 8.00008 6.05747 8.00008ZM12.3333 1.724H9.94253C9.78465 1.7266 9.63382 1.80678 9.52217 1.94745C9.41053 2.08813 9.34689 2.27818 9.34483 2.4771V14.2757H12.931V2.4771C12.931 2.27737 12.8681 2.08581 12.756 1.94458C12.6439 1.80334 12.4919 1.724 12.3333 1.724Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgGraph;
